import { FilterInputProps } from '@customer/filters/types';
import TimeOfDayFilter from './TimeOfDayFilter';
import { useTranslation } from 'react-i18next';
import { setTimeOfDayEnd } from '@customer/store/slices/filtersSlice';

export const TimeOfDayEndFilter = ({
  label,
  elementRef,
}: FilterInputProps<HTMLVdsBasicDropdownElement>) => {
  const { t } = useTranslation();

  return (
    <TimeOfDayFilter
      filterName="timeOfDayEnd"
      label={label ?? t('TimeOfDayEnd')}
      elementRef={elementRef}
      action={setTimeOfDayEnd}
    />
  );
};

export default TimeOfDayEndFilter;
